import React, { useEffect, useState } from 'react';
import { ShoppingBagIcon, XIcon, MapPinIcon, CheckCircleIcon } from 'lucide-react';
const NAMES = ['Martín', 'Lucía', 'Santiago', 'Valentina', 'Mateo', 'Camila', 'Benjamín', 'Sofía', 'Thiago', 'Emma', 'Joaquín', 'Mía', 'Bautista', 'Isabella', 'Lautaro', 'Catalina', 'Felipe', 'Julieta', 'Tomás', 'Delfina'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'Neuquén', 'Bahía Blanca', 'Resistencia', 'Posadas', 'San Juan', 'Paraná', 'Formosa', 'San Luis', 'Río Gallegos', 'Ushuaia', 'Bariloche'];
const TIMES = ['hace 2 minutos', 'hace 5 minutos', 'hace 8 minutos', 'hace 12 minutos', 'hace 15 minutos', 'hace 23 minutos', 'hace 30 minutos', 'hace 45 minutos', 'hace 1 hora'];
interface SaleData {
  name: string;
  city: string;
  time: string;
}
export function SalesNotification() {
  const [isVisible, setIsVisible] = useState(false);
  const [sale, setSale] = useState<SaleData | null>(null);
  const generateRandomSale = () => {
    const name = NAMES[Math.floor(Math.random() * NAMES.length)];
    const city = CITIES[Math.floor(Math.random() * CITIES.length)];
    const time = TIMES[Math.floor(Math.random() * TIMES.length)];
    return {
      name,
      city,
      time
    };
  };
  useEffect(() => {
    // Initial delay before the first notification
    const initialTimeout = setTimeout(() => {
      setSale(generateRandomSale());
      setIsVisible(true);
      // Hide after 5 seconds
      const hideTimeout = setTimeout(() => {
        setIsVisible(false);
      }, 5000);
      return () => clearTimeout(hideTimeout);
    }, 8000);
    // Loop every 30 seconds
    const interval = setInterval(() => {
      setSale(generateRandomSale());
      setIsVisible(true);
      // Hide after 5 seconds
      const hideTimeout = setTimeout(() => {
        setIsVisible(false);
      }, 5000);
      return () => clearTimeout(hideTimeout);
    }, 30000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  const handleClose = () => {
    setIsVisible(false);
  };
  if (!sale) return null;
  return <div className={`fixed bottom-4 left-4 z-50 transition-all duration-500 transform ${isVisible ? 'translate-x-0 opacity-100' : '-translate-x-full opacity-0'}`} data-id="element-141">
      <div className="bg-white rounded-xl shadow-lg border border-gray-100 p-4 max-w-[320px] flex items-start gap-3 relative overflow-hidden" data-id="element-142">
        {/* Decorative accent line */}
        <div className="absolute left-0 top-0 bottom-0 w-1 bg-[#E6007A]" data-id="element-143" />

        {/* Close button */}
        <button onClick={handleClose} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 transition-colors" aria-label="Cerrar notificación" data-id="element-144">
          <XIcon className="w-3 h-3" data-id="element-145" />
        </button>

        {/* Icon */}
        <div className="flex-shrink-0 bg-pink-50 p-2 rounded-full" data-id="element-146">
          <CheckCircleIcon className="w-5 h-5 text-[#E6007A]" data-id="element-147" />
        </div>

        {/* Content */}
        <div className="flex-1 pr-4" data-id="element-148">
          <p className="text-sm font-bold text-gray-900" data-id="element-149">
            {sale.name} compró un Proyector
          </p>
          <div className="flex items-center text-xs text-gray-500 mt-1 gap-1" data-id="element-150">
            <MapPinIcon className="w-3 h-3" data-id="element-151" />
            <span data-id="element-152">{sale.city}, Argentina</span>
          </div>
          <p className="text-xs text-gray-400 mt-1" data-id="element-153">{sale.time}</p>
        </div>
      </div>
    </div>;
}